//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import imageS3Resize from '@/utils/generateResizerLink';

export default {
  computed: {
    ...mapGetters('courses', ['computedCoursesBranding']),
    topBannerIsActiveComputed() {
      return this.computedCoursesBranding?.topBannerIsActive;
    },
    linkTo() {
      return this.computedCoursesBranding?.linkTo;
    },
    computedLinkIsNotEmpty() {
      return this.computedCoursesBranding?.linkTo?.length > 0;
    },
    topBannerBackgroundDesktopImageFileLinkComputed() {
      return this.computedCoursesBranding?.topBannerBackgroundDesktopImageFile
        ?.url;
    },
    topBannerBackgroundDesktopImageFileLinkComputedNotEmpty() {
      return this.topBannerBackgroundDesktopImageFileLinkComputed?.length > 0;
    },
    topBannerBackgroundMobileImageFileLinkComputed() {
      return this.computedCoursesBranding?.topBannerBackgroundMobileImageFile
        ?.url;
    },
    topBannerBackgroundMobileImageFileLinkComputedNotEmpty() {
      return this.topBannerBackgroundMobileImageFileLinkComputed?.length > 0;
    },
    topBannerBackgroundDesktopX2ImageFileLinkComputed() {
      return this.computedCoursesBranding?.topBannerBackgroundDesktopX2ImageFile
        ?.url;
    },
    topBannerBackgroundMobileX2ImageFileLinkComputed() {
      return this.computedCoursesBranding?.topBannerBackgroundMobileX2ImageFile
        ?.url;
    },
    desktopImageSrcSetComputed() {
      let srcsetArr = [];

      if (this.topBannerBackgroundDesktopImageFileLinkComputed?.length > 0) {
        srcsetArr.push(
          `${imageS3Resize({
            link: this.topBannerBackgroundDesktopImageFileLinkComputed,
            size: '1168xAUTO',
          })} 1x`,
        );
      }

      if (this.topBannerBackgroundDesktopX2ImageFileLinkComputed?.length > 0) {
        srcsetArr.push(
          `${imageS3Resize({
            link: this.topBannerBackgroundDesktopX2ImageFileLinkComputed,
            size: '2336xAUTO',
          })} 2x`,
        );
      }

      return srcsetArr.toString();
    },
    mobileImageSrcSetComputed() {
      let srcArr = [];

      if (this.topBannerBackgroundMobileImageFileLinkComputed?.length > 0) {
        srcArr.push(
          `${imageS3Resize({
            link: this.topBannerBackgroundMobileImageFileLinkComputed,
            size: '600xAUTO',
          })} 1x`,
        );
      }

      if (this.topBannerBackgroundMobileX2ImageFileLinkComputed?.length > 0) {
        srcArr.push(
          `${imageS3Resize({
            link: this.topBannerBackgroundMobileX2ImageFileLinkComputed,
            size: '1200xAUTO',
          })} 2x`,
        );
      }

      return srcArr.toString();
    },
    termsAndConditionsTextComputed() {
      return this.computedCoursesBranding?.termsAndConditionsText;
    },
    termsAndConditionsTextNotEmptyComputed() {
      return this.termsAndConditionsTextComputed?.length > 0;
    },
  },
};
